export default {
  CancelarRecorrencia: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "cancelar-pedido-recorrente"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/CancelarRecorrencia.js
// module id = 2s5j
// module chunks = 18